import { View, Text, StyleSheet } from 'react-native'
import { router } from 'expo-router'
import { Like } from '@/src/assets/icons/Like'
import { useDisableSwipingBackToThePreviousPage } from '@/src/common/hooks/disableSwipingBackToThePreviousPage'
import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { CashForMortgageStore } from '../statsig/store'
import { useLogError } from '@/src/common/hooks/useLogError'
import { DesignSystem } from '@/src/design-system'
import { mesaColorNames, typography } from '@/src/common/theme'
import { Button } from '@/src/common/components/Button'
import { useEffect } from 'react'

function SuccessConfirmation() {
  const { pointsToRedeem, remainingPoints, creditAmount, conversionRate } =
    CashForMortgageStore.useCashForMortgage()

  const logError = useLogError()

  useDisableSwipingBackToThePreviousPage()

  useEffect(() => {
    if (!pointsToRedeem || !remainingPoints || !creditAmount || !conversionRate) {
      logError('Missing required data for redemption confirmation', {
        pointsToRedeem,
        remainingPoints,
        creditAmount,
        conversionRate,
      })
    }
  }, [pointsToRedeem, remainingPoints, creditAmount, conversionRate, logError])

  return (
    <StandaloneWrapper
      screen="/main/points-to-cash-for-mortgage/success-confirmation"
      title="Redemption Confirmation"
      profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
    >
      <View style={styles.successContainer}>
        <View style={styles.successIcon}>
          <Like />
        </View>
        <Text style={styles.successText}>Mesa Points successfully redeemed</Text>
      </View>

      <DesignSystem.PointsRedemption.PointsRedemptionConfirmationInfoCard
        pointsToRedeem={pointsToRedeem ? parseInt(pointsToRedeem) : 0}
        remainingPoints={remainingPoints ? parseInt(remainingPoints) : 0}
        creditAmount={creditAmount ? parseInt(creditAmount) : 0}
        conversionRate={conversionRate ?? ''}
      />

      <Button onPress={() => router.dismissTo('/main/rewards')} title="Return Home" />
    </StandaloneWrapper>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'],
    paddingHorizontal: 14,
    gap: 32,
    color: mesaColorNames['global/grey/80 #2F3133'],
  },
  successContainer: {
    gap: 16,
    alignItems: 'center',
    paddingVertical: 20,
  },
  successIcon: {
    backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
    borderRadius: 48,
    padding: 16,
    alignItems: 'center',
  },
  successText: {
    ...typography['heading/heading3'],
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
  },
  infoText: {
    ...typography.S,
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    marginBottom: 40,
  },
})

export const SuccessConfirmationScreen = {
  Screen: SuccessConfirmation,
  Name: 'success-confirmation',
}
